import { AnyAction } from "redux";
import {
  FETCH_SHIPPING_PAGE_ERROR,
  FETCH_SHIPPING_PAGE_SUCCESS,
  REQUEST_FETCH_SHIPPING_PAGE,
} from "redux/actions/pages/shipping";

const defaultState = {
  data: {},
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_FETCH_SHIPPING_PAGE:
      return {
        ...state,
        loading: true,
      };
    case FETCH_SHIPPING_PAGE_SUCCESS:
      return {
        data: action.shipping,
        error: null,
        loading: false,
      };
    case FETCH_SHIPPING_PAGE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
